<app-image-grid [images]="images()"> </app-image-grid>
